<template lang="pug">
  .container-main.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/merchants-information") 商户资料
          el-breadcrumb-item 资料变更详情
    cBox.display-flex(v-loading="loading", :element-loading-fullscreen="false")
      .confirm-content
        h3 资料变更状态总览
        .confirm-row
          .col-new-title 商户资料变更状态
          .col-status
            .green(v-if='auditStatus === 2') {{ auditStatus | merchants_audit_status}}
            .red(v-else-if='auditStatus === 3') {{ auditStatus | merchants_audit_status}}
            span(v-else) {{ auditStatus | merchants_audit_status}}
        .confirm-row(v-if ="source.type ===1 && source.settle_type ===3")
          .col-new-title 钱包提现账号变更
          .col-status
            .audit-wallet(v-for="item in auditWalletList", :key="item.wallet_id")
              .wallet-title {{item.wallet_title}}{{item.wallet_id?`${(item.wallet_id)}`:''}}
              .wallet-status-1(v-if='item.audit_status===1') 待审核
              .wallet-status-2(v-if='item.audit_status===2') 审核成功
              .wallet-status-3(v-if='item.audit_status===3') 审核失败
              .wallet-failed-reason(v-if='item.audit_status===3') {{item.failed_reason}}  
        .confirm-row(v-if='auditStatus === 3 && auditWalletList.length >0 && source.settle_type ===3  && !allFalse')
            .col-new-title 操作
            .col-status
              el-button(type="primary", @click="to('/merchants-wallet/edit')") 修改失败的钱包信息      
      .confirm-content
        h3 资料变更情况
        .block-info(v-if='source.type ===1')
          .header
            .title 商户资料变更 {{ auditStatus | merchants_audit_status}}
            .btn(v-if="show.business",@click="show.business = false") 收起
            .btn(v-else,@click="show.business = true") 展开
          template(v-if="show.business")
            .confirm-row
              .col-name
              .col-new-info.font-size-20.bold 变更资料
              .col-old-info.font-size-20.bold 当前资料
            h4 基本信息
            .confirm-row
              .col-name 商户主体类型
              .col-new-info 公司
              .col-old-info(v-if='basicSource.status=== 3') 公司
            .confirm-row    
              .col-name 公司名称
              .col-new-info
                .txt-diff(v-if='source.mch_name !== basicSource.mch_name') {{source.mch_name || '未填写'}}
                span(v-else) {{source.mch_name || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.mch_name || '未填写'}}
            .confirm-row   
              .col-name 营业执照类型
              .col-new-info
                .txt-diff(v-if='source.opt !== basicSource.opt') {{source.opt === 1 ? '三证合一，一证一码' : '一证三码，三码独立'}}
                span(v-else) {{source.opt === 1 ? '三证合一，一证一码' : '一证三码，三码独立'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.opt === 1 ? '三证合一，一证一码' : '一证三码，三码独立'}}
            .confirm-row(v-if='source.opt === 1')    
              .col-name 注册号/统一社会信用代码
              .col-new-info
                .txt-diff(v-if='source.uni_credit !== basicSource.uni_credit') {{source.uni_credit || '未填写'}}
                span(v-else) {{source.uni_credit || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.uni_credit || '未填写'}}
            .confirm-row(v-if='source.opt === 2')    
              .col-name 营业执照号
              .col-new-info
                .txt-diff(v-if='source.business_license !== basicSource.business_license') {{source.business_license || '未填写'}}
                span(v-else) {{source.business_license || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.business_license || '未填写'}}
            .confirm-row(v-if='source.opt === 2')    
              .col-name 组织机构代码
              .col-new-info
                .txt-diff(v-if='source.organization_code !== basicSource.organization_code') {{source.organization_code || '未填写'}}
                span(v-else) {{source.organization_code || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.organization_code || '未填写'}}
            .confirm-row(v-if='source.opt === 2')    
              .col-name 税务登记证件号
              .col-new-info
                .txt-diff(v-if='source.tex_registration_no !== basicSource.tex_registration_no') {{source.tex_registration_no || '未填写'}}
                span(v-else) {{source.tex_registration_no || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.tex_registration_no || '未填写'}}
            .confirm-row    
              .col-name 营业执照图片
              .col-new-info
                img(v-if="source.business_license_pic", :src="source.business_license_pic | image",
                    @click="$zoom($options.filters.image(source.business_license_pic))", :style="{border:(source.business_license_pic!==basicSource.business_license_pic?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info(v-if='basicSource.status=== 3')
                img(v-if="basicSource.business_license_pic", :src="basicSource.business_license_pic | image",
                    @click="$zoom($options.filters.image(basicSource.business_license_pic))").mch-image
                template(v-else) 未提交
            h4 法人信息
            .confirm-row    
              .col-name 法人姓名
              .col-new-info
                .txt-diff(v-if='source.legal_per_name !== basicSource.legal_per_name') {{source.legal_per_name || '未填写'}}
                span(v-else) {{source.legal_per_name || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.legal_per_name || '未填写'}}
            .confirm-row    
              .col-name 法人手机
              .col-new-info
                .txt-diff(v-if='source.legal_per_telephone_no !== basicSource.legal_per_telephone_no') {{source.legal_per_telephone_no || '未填写'}}
                span(v-else) {{source.legal_per_telephone_no || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.legal_per_telephone_no || '未填写'}}
            .confirm-row    
              .col-name 证件类型
              .col-new-info
                .txt-diff(v-if='source.legal_per_id_type !== basicSource.legal_per_id_type') {{source.legal_per_id_type | resp_per_id_type}}
                span(v-else) {{source.legal_per_id_type | resp_per_id_type}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.legal_per_id_type | resp_per_id_type}}
            .confirm-row    
              .col-name 证件号码
              .col-new-info
                .txt-diff(v-if='source.legal_per_id_no !== basicSource.legal_per_id_no') {{source.legal_per_id_no || '未填写'}}
                span(v-else) {{source.legal_per_id_no || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.legal_per_id_no || '未填写'}}
            //- .confirm-row    
            //-   .col-name 证件有效期
            //-   .col-new-info
            //-     .txt-diff(v-if='source.mch_name !== basicSource.mch_name') {{source.mch_name || '未填写'}}
            //-     span(v-else) {{source.mch_name || '未填写'}}
            //-   .col-old-info {{basicSource.mch_name || '未填写'}}
            .confirm-row    
              .col-name 身份证(人像面)
              .col-new-info
                img(v-if="source.legal_per_id_positive", :src="source.legal_per_id_positive | image",
                    @click="$zoom($options.filters.image(source.legal_per_id_positive))", :style="{border:(source.legal_per_id_positive!==basicSource.legal_per_id_positive?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info(v-if='basicSource.status=== 3')
                img(v-if="basicSource.legal_per_id_positive", :src="basicSource.legal_per_id_positive | image",
                    @click="$zoom($options.filters.image(basicSource.legal_per_id_positive))").mch-image
                template(v-else) 未提交
            .confirm-row    
              .col-name 身份证(国徽面)
              .col-new-info
                img(v-if="source.legal_per_id_opposite", :src="source.legal_per_id_opposite | image",
                    @click="$zoom($options.filters.image(source.legal_per_id_opposite))", :style="{border:(source.legal_per_id_opposite!==basicSource.legal_per_id_opposite?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info(v-if='basicSource.status=== 3')
                img(v-if="basicSource.legal_per_id_opposite", :src="basicSource.legal_per_id_opposite | image",
                    @click="$zoom($options.filters.image(basicSource.legal_per_id_opposite))").mch-image
                template(v-else) 未提交
            h4 责任人信息
            .confirm-row    
              .col-name 责任人姓名
              .col-new-info
                .txt-diff(v-if='source.resp_per_name !== basicSource.resp_per_name') {{source.resp_per_name || '未填写'}}
                span(v-else) {{source.resp_per_name || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.resp_per_name || '未填写'}}
            .confirm-row    
              .col-name 责任人证件类型
              .col-new-info
                .txt-diff(v-if='source.resp_per_id_type !== basicSource.resp_per_id_type') {{source.resp_per_id_type | resp_per_id_type}}
                span(v-else) {{source.resp_per_id_type | resp_per_id_type}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.resp_per_id_type | resp_per_id_type}}
            .confirm-row    
              .col-name 责任人证件号码
              .col-new-info
                .txt-diff(v-if='source.resp_per_id_no !== basicSource.resp_per_id_no') {{source.resp_per_id_no || '未填写'}}
                span(v-else) {{source.resp_per_id_no || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.resp_per_id_no || '未填写'}}              
        .block-info(v-else)
          .header
            .title 商户资料变更 {{ auditStatus | merchants_audit_status}}
            .btn(v-if="show.business",@click="show.business = false") 收起
            .btn(v-else,@click="show.business = true") 展开
          template(v-if="show.business")
            .confirm-row
              .col-name
              .col-new-info.font-size-20.bold 变更资料
              .col-old-info.font-size-20.bold 当前资料
            h4 基本信息
            .confirm-row
              .col-name 商户主体类型
              .col-new-info 个人
              .col-old-info(v-if='basicSource.status=== 3') 个人
            .confirm-row    
              .col-name 姓名
              .col-new-info
                .txt-diff(v-if='source.resp_per_name !== basicSource.resp_per_name') {{source.resp_per_name || '未填写'}}
                span(v-else) {{source.resp_per_name || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.resp_per_name || '未填写'}}
            .confirm-row    
              .col-name 证件号码
              .col-new-info
                .txt-diff(v-if='source.resp_per_id_no !== basicSource.resp_per_id_no') {{source.resp_per_id_no || '未填写'}}
                span(v-else) {{source.resp_per_id_no || '未填写'}}
              .col-old-info(v-if='basicSource.status=== 3') {{basicSource.resp_per_id_no || '未填写'}}
            .confirm-row    
              .col-name 营业执照
              .col-new-info
                img(v-if="source.business_license_pic", :src="source.business_license_pic | image",
                    @click="$zoom($options.filters.image(source.business_license_pic))", :style="{border:(source.business_license_pic!==basicSource.business_license_pic?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info(v-if='basicSource.status=== 3')
                img(v-if="basicSource.business_license_pic", :src="basicSource.business_license_pic | image",
                    @click="$zoom($options.filters.image(basicSource.business_license_pic))").mch-image
                template(v-else) 未提交
            .confirm-row    
              .col-name 身份证(人像面)
              .col-new-info
                img(v-if="source.resp_per_id_positive", :src="source.resp_per_id_positive | image",
                    @click="$zoom($options.filters.image(source.resp_per_id_positive))", :style="{border:(source.resp_per_id_positive!==basicSource.resp_per_id_positive?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info(v-if='basicSource.status=== 3')
                img(v-if="basicSource.resp_per_id_positive", :src="basicSource.resp_per_id_positive | image",
                    @click="$zoom($options.filters.image(basicSource.resp_per_id_positive))").mch-image
                template(v-else) 未提交
            .confirm-row    
              .col-name 身份证(国徽面)
              .col-new-info
                img(v-if="source.resp_per_id_opposite", :src="source.resp_per_id_opposite | image",
                    @click="$zoom($options.filters.image(source.resp_per_id_opposite))", :style="{border:(source.resp_per_id_opposite!==basicSource.resp_per_id_opposite?'1px solid red':'none')}").mch-image
                template(v-else) 未提交
              .col-old-info(v-if='basicSource.status=== 3')
                img(v-if="basicSource.resp_per_id_opposite", :src="basicSource.resp_per_id_opposite | image",
                    @click="$zoom($options.filters.image(basicSource.resp_per_id_opposite))").mch-image
                template(v-else) 未提交
        .block-info(v-if='source.type ===1')
          .header
            .title 钱包提现账号信息
            .btn(v-if="show.wallet",@click="show.wallet = false") 收起
            .btn(v-else,@click="show.wallet = true") 展开
          template(v-if="show.wallet")
            .confirm-wallet(v-for='(item,idx) in confirm_mch_public_draft_list',:key="idx")
              .header
                .title 
                  span 钱包-{{item.wallet_title || '-'}}
                  .wallet-status-1(v-if='item.audit_status===1') (待审核)
                  .wallet-status-2(v-if='item.audit_status===2') (审核成功)
                  .wallet-status-3(v-if='item.audit_status===3') (审核失败：
                  .wallet-failed-reason(v-if='item.audit_status===3') {{item.failed_reason || "空"}})
                .btn(v-if="item.show",@click="item.show = false") 收起
                .btn(v-else,@click="item.show = true") 展开
              template(v-if="item.show")
                .confirm-row    
                  .col-name 开户名
                  .col-new-info
                    .txt-diff(v-if='item.public_account_name !== item.source.public_account_name') {{item.public_account_name || '未填写'}}
                    span(v-else) {{item.public_account_name || '未填写'}}
                  .col-old-info(v-if="item.public_draft_type != 1") {{item.source.public_account_name || '未填写'}}
                .confirm-row    
                  .col-name 开户银行
                  .col-new-info
                    .txt-diff(v-if='item.deposit_bank !== item.source.deposit_bank') {{`${item.deposit_bank}` || '未填写'}}
                    span(v-else) {{`${item.deposit_bank}` || '未填写'}}
                  .col-old-info(v-if="item.public_draft_type != 1") {{`${item.source.deposit_bank}` || '未填写'}}
                .confirm-row    
                  .col-name 开户银行所在地
                  .col-new-info
                    .txt-diff(v-if='item.deposit_bank_city !== item.source.deposit_bank_city') {{`${item.deposit_bank_province}${item.deposit_bank_city}` || '未填写'}}
                    span(v-else) {{`${item.deposit_bank_province}${item.deposit_bank_city}` || '未填写'}}
                  .col-old-info(v-if="item.public_draft_type != 1")  {{`${item.source.deposit_bank_province}${item.source.deposit_bank_city}` || '未填写'}}
                .confirm-row    
                  .col-name 支行名称
                  .col-new-info
                    .txt-diff(v-if='item.sub_branch_bank !== item.source.sub_branch_bank') {{item.sub_branch_bank || '未填写'}}({{item.union_bank}})
                    span(v-else) {{item.sub_branch_bank || '未填写'}}({{item.union_bank}})
                  .col-old-info(v-if="item.public_draft_type != 1") {{item.source.sub_branch_bank || '未填写'}}({{item.source.union_bank}})
                .confirm-row    
                  .col-name 对公账户账号
                  .col-new-info
                    .txt-diff(v-if='item.public_account !== item.source.public_account') {{item.public_account || '未填写'}}
                    span(v-else) {{item.public_account || '未填写'}}
                  .col-old-info(v-if="item.public_draft_type != 1") {{item.source.public_account || '未填写'}}
                .confirm-row    
                  .col-name 对公账户证明
                  .col-new-info(v-if="item.public_draft_type != 1")
                    img(v-if="item.public_account_pic", :src="item.public_account_pic | image",
                        @click="$zoom($options.filters.image(item.public_account_pic))", :style="{border:(item.public_account_pic!==item.source.public_account_pic?'1px solid red':'none')}").mch-image
                    template(v-else) 未提交
                  .col-old-info
                    img(v-if="item.public_account_pic", :src="item.public_account_pic | image",
                        @click="$zoom($options.filters.image(item.source.public_account_pic))").mch-image
                    template(v-else) 未提交
      .confirm-content
        h3 资料修改申请
        .edit-img
          .img-block(v-for="(item,$index) in change_apply_pic")
            img(v-if="item", :src="item | image", @click="$zoom($options.filters.image(item))").mch-image.mr-20
          template(v-if="change_apply_pic.length===0") 未上传
      .align-center
        el-button(type="primary", @click="revokeEdit(source.id)", :disabled="!(auditStatus === 0)") 撤回资料编辑
        el-button(@click="toMain()") 返回商家资料
    verifier(ref="modifyMch", @success_verify="toSaveEdit", @abort="abortEdit", scene="MODIFY_INFO", opt="MCH_VERIFY")
</template>

<script>
import { errorDictionaries } from "@/gadgets/dictionaries";
export default {
  data() {
    return {
      step: 0,
      source: {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null,
        change_apply_pic: null,
        opt: 1,
        origin_mch: {},
      },
      basicSource: {
        type: 1,
        mch_name: null,
        business_license: null,
        legal_per_name: null,
        resp_per_id_type: "01",
        resp_per_id_no: null,
        resp_per_name: null,
        resp_per_telephone_no: null,
        resp_per_email: null,
        tel: null,
        business_address: null,
        settle_type: 1,
        deposit_bank: null,
        deposit_bank_province: null,
        deposit_bank_city: null,
        business_license_pic: null,
        business_license_pic_preview: null,
        resp_per_id_positive: null,
        resp_per_id_positive_preview: null,
        resp_per_id_opposite: null,
        resp_per_id_opposite_preview: null,
        legal_per_id_no: null,
        legal_per_id_type: "01",
        organization_code: null,
        public_account: null,
        public_account_name: null,
        public_account_pic: null,
        sub_branch_bank: null,
        tax_registration_no: null,
        union_bank: null,
        legal_per_id_opposite: null,
        legal_per_id_positive: null,
        legal_per_telephone_no: null,
        uni_credit: null,
        class_code: "",
        area_code: "",
        bankArea: {},
        bankClass: {},
        bank: {},
        deposit_bank_id: null,
        area_id: null,
        change_apply_pic: null,
        opt: 1,
        origin_mch: {},
      },
      change_apply_pic: [],
      mch_public_draft_list: [],
      base_mch_public_draft_list: {},
      confirm_mch_public_draft_list: [],
      uploadURL: "/mch_web/v1/upload_picture",
      loading: false,
      bankClassList: [],
      bankAreaList: [],
      bankList: [],
      editPublicObj: {
        bankArea: {},
        bankClass: {},
        bank: {},
        public_account: "",
      },
      auditStatus: "",
      auditWalletList: [],
      auditWalletEnum: {},
      show: {
        business: true,
        wallet: true,
      },
      walletStatus: "",
      allFalse: false,
    };
  },
  watch: {
    "source.mch_name"(newVal, oldVal) {
      this.synchronizationPublic(newVal);
    },
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },
  filters: {
    type(source) {
      switch (source) {
        case 1:
          return "公司";
        case 2:
          return "个人";
        default:
          return source;
      }
    },
    status(source) {
      if (!source && source !== 0) {
        return "-";
      }
      switch (parseInt(source)) {
        case 1:
          return "填写中";
        case 2:
          return "审批中";
        case 3:
          return "审批通过";
        case 4:
          return "审批失败";
        case 5:
          return "用户撤回修改";
        case 6:
          return "审批中";
        default:
          return source;
      }
    },
    settle_type(source) {
      switch (source) {
        case 1:
          return "银行账号";
        case 2:
          return "钱包账号";
        default:
          return source;
      }
    },
    resp_per_id_type(source) {
      switch (source) {
        case "01":
          return "身份证";
        default:
          return source;
      }
    },
  },
  methods: {
    nextStep() {
      // 判断当前页面
      if (this.step === 1) {
        this.confirmWallet();
        this.step++;
      }
      if (this.step === 0) {
        if (this.validateStep1()) {
          this.step++;
        }
      }
    },
    // 匹对钱包信息校验
    confirmWallet() {
      this.confirm_mch_public_draft_list = this.mch_public_draft_list.map((item, idx) => {

        const obj = { ...item, show: true };
        if (this.base_mch_public_draft_list[item.public_id]) {
          Object.assign(obj, { source: this.base_mch_public_draft_list[item.public_id] });
          console.log(2, this.base_mch_public_draft_list[item.public_id]);
        }else{
          Object.assign(obj, { source: {} });
        }
        if (this.auditWalletEnum[item.wallet_id]) {
          Object.assign(obj, this.auditWalletEnum[item.wallet_id]);
        }
        console.log(3,obj)
        return obj;
      });
    },
    synchronizationPublic(publicName) {
      if (this.mch_public_draft_list.length && this.mch_public_draft_list.length > 0) {
        this.mch_public_draft_list.forEach((item) => {
          item.public_account_name = publicName;
        });
      }
    },
    async editPublic(idx) {
      let newValue = this.mch_public_draft_list[idx];
      newValue.isEdit = true;
      this.$set(this.mch_public_draft_list, idx, newValue);
      this.editPublicObj = Object.assign(this.editPublicObj, newValue);
      await this.handleData();
    },
    // 获取回选的开户行 地 支行的信息
    async handleData() {
      this.editPublicObj.bankClass = {
        class_code: this.editPublicObj.deposit_bank_id,
        class_name: this.editPublicObj.deposit_bank,
      };
      await this.getBankAreaList();
      this.editPublicObj.bankArea = {
        area_code: this.editPublicObj.area_id,
        city_name: this.editPublicObj.deposit_bank_province,
        province_name: this.editPublicObj.deposit_bank_city,
      };
      await this.getBankList();
      this.editPublicObj.bank = {
        bank_code: this.editPublicObj.union_bank,
        bank_name: this.editPublicObj.sub_branch_bank,
      };
    },
    confirmPublic(idx) {
      if (!this.editPublicObj.bankClass.class_code) {
        this.$message({
          type: "warning",
          message: `请选择开户银行`,
        });
        return;
      } else if (!this.editPublicObj.bankArea.area_code) {
        this.$message({
          type: "warning",
          message: `请选择开户银行所在地`,
        });
        return;
      } else if (!this.editPublicObj.bank.bank_code) {
        this.$message({
          type: "warning",
          message: `请选择支行名称`,
        });
        return;
      } else if (!this.editPublicObj.public_account) {
        this.$message({
          type: "warning",
          message: `请输入对公账户账号`,
        });
        return;
      } else if (!this.editPublicObj.public_account_pic) {
        this.$message({
          type: "warning",
          message: `请上传对公账户证明`,
        });
        return;
      }
      let newValue = this.mch_public_draft_list[idx];
      Object.assign(newValue, {
        area_id: this.editPublicObj.area_id,
        deposit_bank: this.editPublicObj.deposit_bank,
        deposit_bank_city: this.editPublicObj.deposit_bank_city,
        deposit_bank_id: this.editPublicObj.deposit_bank_id,
        deposit_bank_province: this.editPublicObj.deposit_bank_province,
        public_account: this.editPublicObj.public_account,
        public_account_name: this.editPublicObj.public_account_name,
        public_account_pic: this.editPublicObj.public_account_pic,
        sub_branch_bank: this.editPublicObj.sub_branch_bank,
        union_bank: this.editPublicObj.union_bank,
        isEdit: false,
        submitMsg: "保存后提交审核",
      });
      this.$set(this.mch_public_draft_list, idx, newValue);
    },
    cancelPublic(idx) {
      let newValue = this.mch_public_draft_list[idx];
      newValue.isEdit = false;
      this.$set(this.mch_public_draft_list, idx, newValue);
    },
    delImg(idx) {
      this.change_apply_pic.splice(idx, 1);
    },
    getUserInfo() {
      return this.$store.dispatch("GET_USER_INFO");
    },
    getMchDetail() {
      this.loading = true;
      const { uname } = this.userInfo;
      return this.$store
        .dispatch("GET_MCH_DETAIL", uname)
        .then(async (data) => {
          let { status, wallet_audit_list, wallet_status } = await this.$store.dispatch(
            "MCH_AUDIT_STATUS"
          );
          let lastInfo = await this.$store.dispatch("LAST_SUCCEED_MCH_DETAIL");
          this.auditStatus = status;
          this.walletStatus = wallet_status;
          if (wallet_audit_list && Array.isArray(wallet_audit_list)) {
            wallet_audit_list.forEach((item) => {
              this.auditWalletEnum[item.wallet_id] = item;
            });
            this.auditWalletList = wallet_audit_list;
          }
          this.allFalse = this.auditWalletList.every((item) => item.audit_status === 3);
          this.source = Object.assign(this.source, data);
          this.basicSource = lastInfo;
          // 判断三证
          this.source.opt = data.uni_credit ? 1 : 2;
          this.basicSource.opt = lastInfo.uni_credit ? 1 : 2;
          // 不要怀疑这个，接口历史原因旧的不改！！！！！
          this.source.tax_registration_no = data.tex_registration_no;
          this.basicSource.tax_registration_no = lastInfo.tex_registration_no;
          if (data.change_apply_pic) {
            this.change_apply_pic = data.change_apply_pic.split(",");
          }

          // 只有企业类型的时候，才需要对公相关的银行信息
          if (this.source.type == 1) {
            if (!data.mch_public_draft_list || data.mch_public_draft_list.length === 0) {
              this.mch_public_draft_list.push({
                public_account_name: data.mch_name,
                isEdit: false,
              });
            } else {
              this.mch_public_draft_list = data.mch_public_draft_list.map((item) => {
                item.public_account_name = data.mch_name;
                item.isEdit = false;
                return item;
              });
            }
            // 只需要展示public_draft_type=1或者=2的数据
            this.mch_public_draft_list = this.mch_public_draft_list.filter((item) => {
              return item.public_draft_type < 3;
            });

            if (
              !lastInfo.mch_public_draft_list ||
              lastInfo.mch_public_draft_list.length === 0
            ) {
              this.base_mch_public_draft_list = {};
            } else {
                lastInfo.mch_public_draft_list.forEach((item)=>{
                  let obj = Object.assign({},item,{'public_account_name':lastInfo.mch_name})
                  this.base_mch_public_draft_list[item.public_id] = obj
                })
            }

            // this.base_mch_public_draft_list = JSON.parse(
            //   JSON.stringify(this.mch_public_draft_list)
            // );
          }

          this.confirmWallet();
          return data;
        })
        .catch((error) => {
          console.log(error);
          const { code, msg } = error;
          this.$alert(`商家资料获取失败。${code}：${msg}`, {
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    uploadChange(file, previewKey, urlKey) {
      const { name, size } = file;
      if (size < 0.5 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          this.$set(this.source, previewKey, result);

          const pic_data = result.split(",")[1];
          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.$set(this.source, urlKey, url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过500KB。", {
          type: "error",
        });
      }
    },

    uploadPublicChange(file, previewKey, urlKey) {
      const { name, size } = file;
      if (size < 2 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          this.$set(this.editPublicObj, previewKey, result);

          const pic_data = result.split(",")[1];
          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.$set(this.editPublicObj, urlKey, url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过2MB。", {
          type: "error",
        });
      }
    },

    uploadListChange(file) {
      const { name, size } = file;
      if (this.change_apply_pic.length >= 9) {
        this.$alert(`图片最多上传9张，请先删除部分图片`, {
          type: "error",
        });
        return;
      }
      if (size < 2 * 1024 * 1024) {
        const fr = new FileReader();
        fr.onload = (e) => {
          this.loading = true;
          const result = e.target.result;
          // this.$set(this[previewKey], result);

          const pic_data = result.split(",")[1];

          //获取尾缀名
          const beginIdx = name.lastIndexOf(".");
          const endIdx = name.length;
          const ext = name.substring(beginIdx + 1, endIdx);
          const params = {
            pic_data,
            ext,
          };
          this.$store
            .dispatch("UPLOAD", params)
            .then(({ url }) => {
              this.change_apply_pic.push(url);
            })
            .catch(({ code, msg }) => {
              this.$alert(`图片上传失败。${code}：${msg}`, {
                type: "error",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        };
        fr.readAsDataURL(file.raw);
      } else {
        this.$alert("图片上传失败。文件大小超过2MB。", {
          type: "error",
        });
      }
    },
    to(pathname) {
      this.$router.push(pathname);
    },

    toMain() {
      this.$router.push("/merchants-information");
    },
    saveEdit() {
      if (this.validate()) {
        this.$refs.modifyMch.init();
      }
    },
    validateStep1() {
      const type = this.source.type;
      if (type === 1) {
        if (!this.source.mch_name) {
          this.$message({
            type: "warning",
            message: `请输入公司名称`,
          });
          return false;
        } else if (!this.source.uni_credit && this.source.opt == 1) {
          this.$message({
            type: "warning",
            message: `请输入统一社会信用代码或注册号`,
          });
          return false;
        } else if (!this.source.business_license && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入营业执照号`,
          });
          return false;
        } else if (!this.source.organization_code && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入组织机构代码`,
          });
          return false;
        } else if (!this.source.tax_registration_no && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入税务登记证件号`,
          });
          return false;
        } else if (!this.source.business_license_pic) {
          this.$message({
            type: "warning",
            message: `请上传营业执照`,
          });
          return false;
        } else if (!this.source.legal_per_name) {
          this.$message({
            type: "warning",
            message: `请输入法人姓名`,
          });
          return false;
        } else if (!this.source.legal_per_telephone_no) {
          this.$message({
            type: "warning",
            message: `请输入法人手机号`,
          });
          return false;
        } else if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: `请输入责任人姓名`,
          });
          return false;
        } else if (!this.source.resp_per_id_no) {
          this.$message({
            type: "warning",
            message: `请输入责任人证件号码`,
          });
          return false;
        } else if (!this.source.legal_per_id_no) {
          this.$message({
            type: "warning",
            message: `请输入法人证件号码`,
          });
          return false;
        } else if (!this.source.legal_per_id_positive) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证正面`,
          });
          return false;
        } else if (!this.source.legal_per_id_opposite) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证反面`,
          });
          return false;
        }
      } else if (type === 2) {
        if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: "请输入个人姓名",
          });
          return false;
        }
      }
      return true;
    },
    validate() {
      const type = this.source.type;
      if (type === 1) {
        if (!this.source.mch_name) {
          this.$message({
            type: "warning",
            message: `请输入公司名称`,
          });
          return false;
        } else if (!this.source.uni_credit && this.source.opt == 1) {
          this.$message({
            type: "warning",
            message: `请输入统一社会信用代码或注册号`,
          });
          return false;
        } else if (!this.source.business_license && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入营业执照号`,
          });
          return false;
        } else if (!this.source.organization_code && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入组织机构代码`,
          });
          return false;
        } else if (!this.source.tax_registration_no && this.source.opt == 2) {
          this.$message({
            type: "warning",
            message: `请输入税务登记证件号`,
          });
          return false;
        } else if (!this.source.business_license_pic) {
          this.$message({
            type: "warning",
            message: `请上传营业执照`,
          });
          return false;
        } else if (!this.source.legal_per_name) {
          this.$message({
            type: "warning",
            message: `请输入法人姓名`,
          });
          return false;
        } else if (!this.source.legal_per_telephone_no) {
          this.$message({
            type: "warning",
            message: `请输入法人手机号`,
          });
          return false;
        } else if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: `请输入责任人姓名`,
          });
          return false;
        } else if (!this.source.legal_per_id_no) {
          this.$message({
            type: "warning",
            message: `请输入法人证件号码`,
          });
          return false;
        } else if (this.mch_public_draft_list.length === 1) {
          if (!this.mch_public_draft_list[0].deposit_bank) {
            this.$message({
              type: "warning",
              message: `请选择开户银行`,
            });
            return false;
          } else if (!this.mch_public_draft_list[0].public_account) {
            this.$message({
              type: "warning",
              message: `请选择开户银行所在地`,
            });
            return false;
          } else if (!this.mch_public_draft_list[0].sub_branch_bank) {
            this.$message({
              type: "warning",
              message: `请选择支行名称`,
            });
            return false;
          } else if (!this.mch_public_draft_list[0].public_account) {
            this.$message({
              type: "warning",
              message: `请输入对公账户账号`,
            });
            return false;
          } else if (!this.mch_public_draft_list[0].public_account_pic) {
            this.$message({
              type: "warning",
              message: `请上传对公账户证明`,
            });
            return false;
          }
        } else if (!this.source.legal_per_id_positive) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证正面`,
          });
          return false;
        } else if (!this.source.legal_per_id_opposite) {
          this.$message({
            type: "warning",
            message: `请上传法人身份证反面`,
          });
          return false;
        }
      } else if (type === 2) {
        if (!this.source.resp_per_name) {
          this.$message({
            type: "warning",
            message: "请输入个人姓名",
          });
          return false;
        }
      }

      if (!this.source.resp_per_id_no) {
        const message = type === 1 ? "请输入责任人证件号" : "请输入证件号码";
        this.$message({
          type: "warning",
          message,
        });
        return false;
      }

      if (this.change_apply_pic.length < 1) {
        this.$message({
          type: "warning",
          message: `请上传修改函`,
        });
        return false;
      }

      return true;
    },

    toSaveEdit(biz_ticket) {
      this.loading = true;
      const source = Object.assign({}, this.source, {
        biz_ticket,
        change_apply_pic: this.change_apply_pic.toString(),
      });
      source.mch_public_list = JSON.stringify(this.mch_public_draft_list);

      const action =
        this.source.type === 1 ? "EDIT_COMPANY_DETAIL" : "EDIT_PERSON_DETAIL";
      this.$store
        .dispatch(action, source)
        .then(() => {
          this.submitMsg = "";
          this.$alert("您的商家资料已提交审核", {
            type: "success",
          }).then(() => {
            this.toMain();
          });
        })
        .catch(({ code, msg }) => {
          if (code === 1004) {
            const start = msg.indexOf("：");
            const key = msg.substring(start + 1);
            const errorMsg = errorDictionaries[key];
            this.$message({
              type: "error",
              message: `${errorMsg}输入有误，请检查后，重新输入`,
            });
          } else {
            this.$message({
              type: "error",
              message: `${msg}`,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    abortEdit() {
      this.$confirm("是否确认放弃未保存的商家信息？", "提示")
        .then(() => {
          this.toMain();
        })
        .catch(() => {});
    },

    // 获取开户银行
    getBankClassList() {
      this.$store
        .dispatch("GET_BANK_CLASS_LIST")
        .then((data) => {
          this.bankClassList = data;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `获取银行列表失败。${code}：${msg}`,
          });
        });
    },

    // 获取开户银行区域
    getBankAreaList() {
      return new Promise((resolve, reject) => {
        if (this.editPublicObj.bankClass.class_code) {
          this.editPublicObj.deposit_bank = this.editPublicObj.bankClass.class_name;
          this.editPublicObj.deposit_bank_id = this.editPublicObj.bankClass.class_code;
          this.$store
            .dispatch("GET_BANK_AREA_LIST", this.editPublicObj.bankClass.class_code)
            .then((data) => {
              this.bankAreaList = data;
              this.editPublicObj.bankArea = {};
              this.editPublicObj.bank = {};
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取银行地区列表失败。${code}：${msg}`,
              });
              resolve();
            });
        } else {
          this.editPublicObj.bankArea = {};
          this.editPublicObj.bank = {};
          this.editPublicObj.area_id = null;
          this.editPublicObj.deposit_bank_id = null;
          this.editPublicObj.deposit_bank = null;
          this.editPublicObj.deposit_bank_city = null;
          this.editPublicObj.sub_branch_bank = null;
          this.editPublicObj.union_bank = null;
          resolve();
        }
      });
    },

    // 获取支行
    getBankList() {
      return new Promise((resolve, reject) => {
        if (this.editPublicObj.bankClass.class_code && this.editPublicObj.bankArea) {
          this.editPublicObj.bankArea = this.editPublicObj.bankArea;
          this.editPublicObj.deposit_bank_province = this.editPublicObj.bankArea.province_name;
          this.editPublicObj.deposit_bank_city = this.editPublicObj.bankArea.city_name;
          this.editPublicObj.area_id = this.editPublicObj.bankArea.area_code;
          const params = {
            class_code: this.editPublicObj.bankClass.class_code,
            area_code: this.editPublicObj.bankArea.area_code,
          };
          this.$store
            .dispatch("GET_BANK_LIST", params)
            .then((data) => {
              this.bankList = data;
              this.editPublicObj.bank = {};
              resolve();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `获取支行列表失败。${code}：${msg}`,
              });
              resolve();
            });
        } else {
          this.editPublicObj.bank = {};
          this.editPublicObj.deposit_bank = null;
          this.editPublicObj.deposit_bank_city = null;
          this.editPublicObj.sub_branch_bank = null;
          this.editPublicObj.union_bank = null;
          resolve();
        }
      });
    },

    // 获取最后的支行
    getBank() {
      if (this.editPublicObj.bank) {
        this.editPublicObj.sub_branch_bank = this.editPublicObj.bank.bank_name;
        this.editPublicObj.union_bank = this.editPublicObj.bank.bank_code;
      } else {
        this.editPublicObj.sub_branch_bank = null;
        this.editPublicObj.union_bank = null;
      }
    },

    revokeEdit(mch_draft_id) {
      this.$confirm("是否确认撤回已提交审批的商家信息？", "提示")
        .then(() => {
          return this.$store
            .dispatch("REVOKE_MCH_DRAFT", mch_draft_id)
            .then(() => {
              this.getMchDetail();

              this.$message({
                type: "success",
                message: "撤回成功",
              });
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `撤回失败。${code}：${msg}`,
              });
            });
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.getMchDetail();
    this.getBankClassList();
  },
};
</script>

<style lang="less" scoped>
.img-block {
  position: relative;
  float: left;
}
.del-img {
  // border: 1px solid red;
  background: red;
  color: #fff;
  position: absolute;
  top: 0;
  right: 20px;
  padding: 0 10px;
  text-align: center;
}
.editPublic {
  text-align: center;
  margin-bottom: 10px;
}
.tipTxt {
  color: red;
  text-align: center;
  margin-bottom: 10px;
}
.display-flex {
  flex-direction: column;
}
.wallet-info {
  border: 1px solid black;
  overflow: hidden;
  padding: 40px 20px 20px;
  margin: 20px;
}
.confirm-content {
  border: 1px solid #eef1f6;
  width: 100%;
  overflow: hidden;
  padding-bottom: 40px;
  h3 {
    // padding-left: 40px;
    padding: 6px 40px;
    background: #eef1f6;
    margin-top: 0;
  }
  .txt-diff {
    color: red;
  }
}
.confirm-wallet {
  overflow: hidden;
  border: 1px solid #c6c6c6;
  margin: 20px;
}
.confirm-row {
  display: flex;
  min-width: 1000px;

  .col-name {
    width: 30%;
    padding-right: 70px;
    text-align: right;
    margin-bottom: 10px;
  }
  .col-new-info {
    width: 35%;
    margin-bottom: 10px;
  }
  .col-old-info {
    width: 35%;
    margin-bottom: 10px;
  }
  .col-new-title {
    width: 20%;
    padding-right: 70px;
    text-align: right;
    margin-bottom: 10px;
  }
  .col-status {
    width: 80%;
    .el-button {
      margin-top: 4px;
    }
  }
}
.audit-wallet {
  display: flex;
  font-size: 16px;
  .wallet {
    &-title {
      margin-right: 40px;
    }
    &-status {
      &-2 {
        color: #67c23a;
      }
      &-3 {
        color: #f56c6c;
      }
    }
    &-failed-reason {
      margin-left: 40px;
    }
  }
}
.more {
  color: #275aa0;
  cursor: pointer;
  display: inline;
  margin-left: 20px;
}
.block-info {
  border: 1px solid #eef1f6;
  width: 92%;
  overflow: hidden;
  margin: 10px auto;
  h4 {
    padding-left: 30px;
  }
  .header {
    padding: 6px 40px;
    background: #eef1f6;
    margin-top: 0;
    overflow: hidden;
  }
  .title {
    float: left;
    font-size: 18px;
    font-weight: 600;
    display: flex;
    span {
      margin-right: 30px;
    }
    .wallet {
      &-status {
        &-2 {
          color: #67c23a;
        }
        &-3 {
          color: #f56c6c;
        }
      }
      &-failed-reason {
        color: #f56c6c;
      }
    }
  }
  .btn {
    float: right;
    cursor: pointer;
    color: #275aa0;
  }
}
.align-center {
  margin-top: 16px;
}
.edit-img {
  padding: 20px 40px;
}
</style>
